import { render, staticRenderFns } from "./CreatePurchasePlanDialog.vue?vue&type=template&id=5f3bc1f0"
import script from "./CreatePurchasePlanDialog.vue?vue&type=script&lang=js"
export * from "./CreatePurchasePlanDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports